import React from 'react'

import { Text, View, Loader } from '@aws-amplify/ui-react'



import { Location } from '@mytmpvpn/mytmpvpn-common/models/location'


export function City({ location }: { location: Location }) {
  if (!location) return <Loader variation='linear' />
  return <View>
    <Text>{location.city}</Text>
  </View>
}

